<div class="wrapper">
  <app-appli-side-bar [sidebars]="sidebar" (clickEventIndex)="setFocusIndex($event)"></app-appli-side-bar>
  <div class="top_icon"></div>
  <div class="app_name">{{ appname }}</div>
  <div class="remote_control"></div>
  <div class="datetime">
    {{ now_date_obj.year }}.{{ now_date_obj.month }}.{{ now_date_obj.day }}
    {{ now_date_obj.hhmm }}
  </div>
  <div class="main_content_wrapper">
    <div class="main_content flex_content">

      <!--
      <div *ngIf="rentalIndex == 0">
        <h1 class="nb_title">
          <span *ngIf="lang=='jpn'">
            デイリーヤマザキ
          </span>
          <span *ngIf="lang=='eng'">
            Daily Yamazaki
          </span>
        </h1>
        <div class="flex_content">
          <div class="nb_infopanel">
            <div class="flex_content">
              <dl>
                <dt>
                  <span *ngIf="lang=='jpn'">
                    アクセス
                  </span>
                  <span *ngIf="lang=='eng'">
                    Access
                  </span>
                </dt>
                <dd>
                  <span *ngIf="lang=='jpn'">
                    徒歩0分(ビル内)
                  </span>
                  <span *ngIf="lang=='eng'">
                    1 minutes on foot
                  </span>
                </dd>
              </dl>
              <dl>
                <dt>

                  <span *ngIf="lang=='jpn'">
                    営業時間
                  </span>
                  <span *ngIf="lang=='eng'">
                    Open
                  </span>
                </dt>
                <dd>
                  <span *ngIf="lang=='jpn'">
                    7:00～23:00
                  </span>
                  <span *ngIf="lang=='eng'">
                    7:00 AM to 11:00 PM
                  </span>
                </dd>
              </dl>
            </div>
            <div class="nb_description">

              <span *ngIf="lang=='jpn'">
                当ホテルと同じビル内(2F)にあるデイリーヤマザキでは、日用雑貨、食品、お酒、お土産品等、ご旅行中の皆様の様々な需要に対応できる商品を取り揃えています。
              </span>
              <span *ngIf="lang=='eng'">
                  Daily Yamazaki, located in the same building (2F) as our hotel, offers a variety of products that meet the various demands of everyone traveling, such as daily goods, food, liquor, and souvenirs.
              </span>
            </div>

          </div>
          <div class="nb_image">
            <img src="/assets/nearby/nb_conveni.jpg">
          </div>


        </div>


      </div>
    -->
      <div *ngIf="rentalIndex == 0">

        <h1 class="nb_title">
          <span *ngIf="lang=='jpn'">
            りんくうプレミアム・アウトレット
          </span>
          <span *ngIf="lang=='eng'">
            RINKU PREMIUM OUTLETS
          </span>
          <qrcode [qrdata]="'https://www.premiumoutlets.co.jp/rinku/'" [width]="70" class="qr-img-box" />
        </h1>
        <div class="flex_content">
          <div class="nb_infopanel">
            <div class="flex_content">
              <dl>
                <dt>
                  <span *ngIf="lang=='jpn'">
                    アクセス
                  </span>
                  <span *ngIf="lang=='eng'">
                    Access
                  </span>
                </dt>
                <dd>
                  <span *ngIf="lang=='jpn'">
                    徒歩7分
                  </span>
                  <span *ngIf="lang=='eng'">
                    7 minutes on foot
                  </span>
                </dd>
              </dl>
              <!-- <dl>
                <dt>

                  <span *ngIf="lang=='jpn'">
                    営業時間
                  </span>
                  <span *ngIf="lang=='eng'">
                    Open
                  </span>
                </dt>
                <dd>
                  <span *ngIf="lang=='jpn'">
                    10:00～20:00
                  </span>
                  <span *ngIf="lang=='eng'">
                    10:00 AM to 8:00 PM
                  </span>
                </dd>
              </dl> -->
            </div>
            <div class="nb_description">

              <span *ngIf="lang=='jpn'">
                「りんくうプレミアム・アウトレット」は国内外の人気ブランドをお得なプライスで購入できるので、お気に入りの商品を探してみましょう。また、敷地内には様々なタイプのレストランやカフェも充実しているので、休憩にぴったり。雨でも一日中大満足で過ごせますね。
              </span>
              <span *ngIf="lang=='eng'">
                The Shopping Complex is designed to attract guests of all ages with its wide range of shops and restaurants. The Ferris Wheel is one of the largest in Kansai and is beautifully illuminated after sunset.
              </span>
            </div>

          </div>
          <div class="nb_image">
            <img src="/assets/nearby/nb_outlet.jpg">
          </div>
        </div>
      </div>

      <div *ngIf="rentalIndex == 1">
        <h1 class="nb_title">
          <span *ngIf="lang=='jpn'">
            りんくうプレジャータウン シークル
          </span>
          <span *ngIf="lang=='eng'">
              Rinku Pleasure Town Seacle
          </span>
          <qrcode [qrdata]="'https://www.seacle.jp/'" [width]="70" class="qr-img-box" />
        </h1>
        <div class="flex_content">
          <div class="nb_infopanel">
            <div class="flex_content">
              <dl>
                <dt>
                  <span *ngIf="lang=='jpn'">
                    アクセス
                  </span>
                  <span *ngIf="lang=='eng'">
                    Access
                  </span>
                </dt>
                <dd>
                  <span *ngIf="lang=='jpn'">
                    徒歩2分
                  </span>
                  <span *ngIf="lang=='eng'">
                    2 minutes on foot
                  </span>
                </dd>
              </dl>
              <!-- <dl>
                <dt>

                  <span *ngIf="lang=='jpn'">
                    営業時間
                  </span>
                  <span *ngIf="lang=='eng'">
                    Open
                  </span>
                </dt>
                <dd>
                  <span *ngIf="lang=='jpn'">
                    10:00～20:00
                    <br> <small>※ 一部異なる場合有</small> </span>
                  <span *ngIf="lang=='eng'">
                    10:00 AM to 8:00 PM
                  </span>
                </dd>
              </dl> -->
            </div>
            <div class="nb_description">

              <span *ngIf="lang=='jpn'">
                大観覧車が目印のショッピングセンター「SEACLE」。

                温浴施設やレストラン、フードコートも充実！

                ファッション、ドラッグストア、

                回転寿司、焼肉、ラーメンなど

                各店舗でお買い物、お食事をお楽しみください。

              </span>
              <span *ngIf="lang=='eng'">
                The Shopping Complex is designed to attract guests of all ages with its wide range of shops and restaurants. The Ferris Wheel is one of the largest in Kansai and is beautifully illuminated after sunset.</span>
            </div>

          </div>
          <div class="nb_image">
            <img src="/assets/nearby/nb_seacle.jpg">
          </div>


        </div>

      </div>
      <div *ngIf="rentalIndex == 2">
        <h1 class="nb_title">
          <span *ngIf="lang=='jpn'">
            りんくう公園
          </span>
          <span *ngIf="lang=='eng'">
            RINKU Park
          </span>
          <qrcode [qrdata]="'http://rinku.osaka-park.or.jp/'" [width]="70" class="qr-img-box" />
        </h1>
        <div class="flex_content">
          <div class="nb_infopanel">
            <div class="flex_content">
              <dl>
                <dt>
                  <span *ngIf="lang=='jpn'">
                    アクセス
                  </span>
                  <span *ngIf="lang=='eng'">
                    Access
                  </span>
                </dt>
                <dd>
                  <span *ngIf="lang=='jpn'">
                    徒歩7分
                  </span>
                  <span *ngIf="lang=='eng'">
                    7 minutes on foot
                  </span>
                </dd>
              </dl>
              <!-- <dl>
                <dt>

                  <span *ngIf="lang=='jpn'">
                    営業時間
                  </span>
                  <span *ngIf="lang=='eng'">
                    Open
                  </span>
                </dt>
                <dd>
                  <span *ngIf="lang=='jpn'">
                    24時間
                  </span>
                  <span *ngIf="lang=='eng'">
                    24H
                  </span>
                </dd>
              </dl> -->
            </div>
            <div class="nb_description">

              <span *ngIf="lang=='jpn'">
                  関西国際空港の対岸にある公園です。海に面する眺望抜群のこの公園からは、関西国際空港から飛び立つ飛行機、
                  遠くには明石海峡大橋や淡路島も望めます。都会と自然の異なる魅力をたっぷりと楽しめる公園となっています。
              </span>
              <span *ngIf="lang=='eng'">
                Park in the neighborhood, with a magnificent view of the Sea and Kansai Airport, is ideal for morning jogs.
                Marble Beach is a great spot to enjoy seeing the take-off and landing of the Airplanes from around the world.
                Highly recommended to visit in the evening time to see the beautiful sunset.                
              </span>
            </div>

          </div>
          <div class="nb_image">
            <img src="/assets/nearby/nb_park.jpg">
          </div>


        </div>
      </div>

      <div *ngIf="rentalIndex == 3">
        <h1 class="nb_title">
          <span *ngIf="lang=='jpn'">
            りんくうの湯            
          </span>
          <span *ngIf="lang=='eng'">
            RINKU NO YU (Public Bath)
          </span>
          <qrcode [value]="'https://rinkunoyu.jp/'" [width]="70" class="qr-img-box" />
        </h1>
        <div class="flex_content">
          <div class="nb_infopanel">
            <div class="flex_content">
              <dl>
                <dt>
                  <span *ngIf="lang=='jpn'">
                    アクセス
                  </span>
                  <span *ngIf="lang=='eng'">
                    Access
                  </span>
                </dt>
                <dd>
                  <span *ngIf="lang=='jpn'">
                    徒歩5分
                  </span>
                  <span *ngIf="lang=='eng'">
                    5 minutes on foot
                  </span>
                </dd>
              </dl>
              <!-- <dl>
                <dt>

                  <span *ngIf="lang=='jpn'">
                    営業時間
                  </span>
                  <span *ngIf="lang=='eng'">
                    Open
                  </span>
                </dt>
                <dd>
                  <span *ngIf="lang=='jpn'">
                    <small>
                    平　日 朝9時～夜1時<br />
                    土日祝 朝7時～夜1時
                    </small>
                  </span>
                  <span *ngIf="lang=='eng'">
                    <small>
                    Weekday 9:00 AM to 1:00 AM<br />
                    Sat,Sun and Holiday Open 7:00 AM 
                    </small>
                  </span>
                </dd>
              </dl> -->
            </div>
            <div class="nb_description">

              <span *ngIf="lang=='jpn'">
                大阪湾を見渡せる優雅な露天風呂や岩盤浴が楽しめます。
                また「健美楽汗房」では、本格的な岩盤浴をお楽しみいただけます。
                館内の約3万冊の漫画や雑誌、さらにテレビ付きのリクライニングチェアやインターネットなども利用できる充実の設備が整っております。
              </span>
              <span *ngIf="lang=='eng'">
                  Rinku no Yu is also just near from Osaka Bay so you can take a bath feeling the sea breeze and looking at the Osaka Bay.That is really blissful moment.
                  Also there are "Germanium bath" and "Rock Salt bath" and other "Stone sauna". After taking the bath you can make yourself at home in the relax room or have lunch or have a massage.
              </span>
            </div>

          </div>
          <div class="nb_image">
            <img src="/assets/nearby/nb_spa.jpg">
          </div>



        </div>
      </div>


    </div>
  </div>